import { createContext, useContext } from 'react';
import { RootStoreMobX } from '../stores/root.store';

export function useStoreCommon() {
  const context = useContext(RootStoreContext);
  if (context === undefined) {
    throw new Error('useRootStore must be used within RootStoreProvider');
  }

  return context;
}

export const RootStoreContext = createContext<RootStoreMobX>(
  {} as RootStoreMobX,
);
